import { InHouseReportRequestModel } from '../api/models/InHouseReportRequestModel';
import { InHouseReportFormModel } from '../models';

export const dataFormToRequest = (data: InHouseReportFormModel): InHouseReportRequestModel => ({
  date: data.date,
  card_ids: data.card_ids.map(card => card.id),
  rate_ids: data.rate_ids,
  room_type_ids: data.room_type_ids,
  day_price: data.day_price,
  nationality_ids: (data.nationality_ids || []).map(Item => Number(Item.id)),
  all_pax: data.all_pax,
  sort_by: data.sortBy,
  direction: data.sortDirection,
  ...(data.grouped ? { group_by: 'market_agency' } : {}),
  file_type: data.file_type,
});
